// MouseTrail.jsx
import { useEffect, useRef } from "react";

const MouseTrail = () => {
  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const segments = 100;
    let points = [];
    let mouse = { x: 0, y: 0 };

    const move = (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (points.length === 0) {
        points = Array.from({ length: segments }, () => ({
          x: mouse.x,
          y: mouse.y,
        }));
      }
    };

    const anim = () => {
      let px = mouse.x;
      let py = mouse.y;
      points.forEach((p, i) => {
        p.x = px;
        p.y = py;
        const n = points[i + 1];
        if (n) {
          px -= (p.x - n.x) * 0.1;
          py -= (p.y - n.y) * 0.1;
        }
      });
      if (pathRef.current) {
        pathRef.current.setAttribute(
          "d",
          `M ${points.map((p) => `${p.x} ${p.y}`).join(" L ")}`
        );
      }
      requestAnimationFrame(anim);
    };

    const resize = () => {
      if (svgRef.current) {
        const ww = window.innerWidth;
        const wh = window.innerHeight;
        svgRef.current.style.width = ww + "px";
        svgRef.current.style.height = wh + "px";
        svgRef.current.setAttribute("viewBox", `0 0 ${ww} ${wh}`);
      }
    };

    document.addEventListener("mousemove", move);
    window.addEventListener("resize", resize);
    const rafId = requestAnimationFrame(anim);
    resize();

    return () => {
      document.removeEventListener("mousemove", move);
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <svg
      ref={svgRef}
      className="trail"
      style={{ position: "fixed", top: 0, left: 0, pointerEvents: "none" }}
    >
      <path
        ref={pathRef}
        style={{
          stroke: "#FFD708",
          strokeWidth: 5,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none",
        }}
      />
    </svg>
  );
};

export default MouseTrail;